export const data = () => ({
  isDebug: true,
  loading: false,
  architecturalRequestID: 0,
  styles: {
    filterButton: {
      float: 'right',
      marginTop: '4px'
    }
  }
})
